export interface Skills {
  name: string;
  proficiency: number;
}

export const programmingLanguages: Skills[] = [
  {
    name: 'JavaScript',
    proficiency: 9,
  },
  {
    name: 'TypeScript',
    proficiency: 9,
  },
  {
    name: 'Python',
    proficiency: 9,
  },
  {
    name: 'C++',
    proficiency: 7,
  },
];

export const javascriptFrameworks: Skills[] = [
  {
    name: 'React',
    proficiency: 9,
  },
  {
    name: 'Angular',
    proficiency: 9,
  },
  {
    name: 'Tailwind',
    proficiency: 8,
  },
  {
    name: 'Serverless',
    proficiency: 5,
  },
  {
    name: 'Node js',
    proficiency: 7,
  },
  {
    name: 'Django/DRF',
    proficiency: 9,
  },
  
  
];

export const devops: Skills[] = [
  {
    name: 'AWS',
    proficiency: 6,
  },
  {
    name: 'Firebase',
    proficiency: 6,
  },
  {
    name: 'Google Cloud',
    proficiency: 4,
  },
];
